// import React, { useState } from "react";

// const CancelRefund = () => {
//   const [isChecked, setIsChecked] = useState(false);

//   const handleCheckboxChange = (e) => {
//     setIsChecked(e.target.checked);
//   };

//   return (
//     <div>
//       <div
//         className="text-center container"
//         style={{
//           boxShadow: "0 0 15px 5px rgba(0, 0, 0, 0.08)",
//           width: "815px",
//           borderRadius: "10px",
//           padding: "20px",
//         }}
//       >
//         <h3 style={{ fontWeight: "bold" }} className="mb-4">
//           Cancel/Refund
//         </h3>

//         <ol className="text-start mx-auto" style={{ maxWidth: "700px" }}>
//           <li>
//             <strong>Cancellation Policy</strong>
//             <ul>
//               <li>
//                 Please cancel or modify your reservation at least 2 hours before
//                 your scheduled time.
//               </li>
//               <li>Late cancellations may incur a fee.</li>
//               <li>
//                 No-shows without prior notice may result in a temporary or
//                 permanent booking restriction.
//               </li>
//               <li>
//                 For group reservations (6+ people), cancellations should be made
//                 at least 24 hours in advance.
//               </li>
//               <li>
//                 If a prepaid booking is canceled late, no refund will be issued.
//               </li>
//               <li>
//                 We reserve the right to release your table if you're more than
//                 15 minutes late without notifying us.
//               </li>
//             </ul>
//           </li>
//         </ol>

//         <label className="my-3 d-block">
//           <input
//             style={{ transform: "scale(1.2)", marginRight: "8px" }}
//             type="checkbox"
//             name="terms"
//             onChange={handleCheckboxChange}
//           />
//           I agree with the conditions
//         </label>

//         {isChecked && (
//           <div className="d-flex justify-content-center gap-4">
//             <button
//               style={{ fontWeight: "bold" }}
//               type="button"
//               className="btn btn-success"
//             >
//               Submit
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CancelRefund;


import React, { useState } from "react";

const CancelRefund = () => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  return (
    <div className="cancel-container">
      <div className="cancel-box">
        <h3 className="cancel-heading">Cancel/Refund</h3>

        <ol className="cancel-list">
          <li>
            <strong>Cancellation Policy</strong>
            <ul>
              <li>
                Please cancel or modify your reservation at least 2 hours before
                your scheduled time.
              </li>
              <li>Late cancellations may incur a fee.</li>
              <li>
                No-shows without prior notice may result in a temporary or
                permanent booking restriction.
              </li>
              <li>
                For group reservations (6+ people), cancellations should be made
                at least 24 hours in advance.
              </li>
              <li>
                If a prepaid booking is canceled late, no refund will be issued.
              </li>
              <li>
                We reserve the right to release your table if you're more than
                15 minutes late without notifying us.
              </li>
            </ul>
          </li>
        </ol>

        <label className="cancel-checkbox">
          <input
            type="checkbox"
            name="terms"
            onChange={handleCheckboxChange}
          />
          I agree with the conditions
        </label>

        {isChecked && (
          <div className="cancel-action">
            <button
              type="button"
              className="btn-submit"
              onClick={() => {
                window.location.href = "/login"
              }}
            >
              Submit
            </button>

          </div>
        )}
      </div>

      {/* Internal CSS */}
      <style>{`
        .cancel-container {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
        }

        .cancel-box {
          max-width: 930px;
          width: 100%;
          padding: 20px;
          border-radius: 10px;
          box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.08);
          background-color: #fff;
          text-align: center;
        }

        .cancel-heading {
          font-weight: bold;
          margin-bottom: 20px;
        }

        .cancel-list {
          text-align: left;
          margin: 0 auto;
          max-width: 700px;
          padding-left: 20px;
        }

        .cancel-list li {
          margin-bottom: 8px;
        }

        .cancel-checkbox {
          display: block;
          margin: 20px 0;
          font-size: 1rem;
        }

        .cancel-checkbox input {
          transform: scale(1.2);
          margin-right: 10px;
        }

        .cancel-action {
          display: flex;
          justify-content: center;
          margin-top: 10px;
        }

        .btn-submit {
          background-color: #28a745;
          color: white;
          border: none;
          padding: 10px 20px;
          font-weight: bold;
          border-radius: 5px;
          cursor: pointer;
          font-size: 1rem;
        }

        .btn-submit:hover {
          background-color: #218838;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .cancel-box {
            padding: 15px;
          }

          .cancel-list {
            padding-left: 15px;
            font-size: 0.95rem;
          }

          .cancel-checkbox {
            font-size: 0.95rem;
          }

          .btn-submit {
            width: 100%;
            padding: 12px;
          }
        }

        @media (max-width: 480px) {
          .cancel-box {
            padding: 10px;
          }

          .cancel-heading {
            font-size: 1.25rem;
          }

          .cancel-list {
            font-size: 0.9rem;
          }

          .btn-submit {
            font-size: 0.95rem;
          }
        }
      `}</style>
    </div>
  );
};

export default CancelRefund;

